// import React, { useEffect, useRef, useState } from "react";
import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getData, patchData, postData, postDataAuth } from "../../Service/ApiMethod";
import { EMAIL, UPDATE_PASSWORD,RECURITER_PROFILE } from "../../Service/service";
import BackBar from "../home/BackBar";
// import { SEND_OTP, VERIFY_OTP } from "../../Service/service";
import UpdatePassword from "./UpdatePassword.png";
import Switch from 'react-js-switch';
import { useTranslation } from "react-i18next";
import { lang } from "../../lang";

const Settings = () => {
  const { t } = useTranslation();
  const [ln,setLn] = useState('en')
  const [currentPassword, setCurrentPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordd, setShowPasswordd] = useState(false);
  const [showPassworddd, setShowPassworddd] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(false);

  const validpassword = (pass) => {
    return pass.match(
      // /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
    );
  }
  
  const switch_onChange_handle = () => {
    setIsSwitchOn(!isSwitchOn);
  };




  const updateEmailStatus = () => {
    // setLoader(true)
    setIsSwitchOn(!isSwitchOn)
    let request = {
      status: !isSwitchOn,
    };
    console.log(request,"cjssssss")
    postData(request,EMAIL)
    .then((response) => response.json())
      .then(res => {
        console.log("responseeeee", res)
        if (res.status_code === 200) {
          console.log('success', res.message);
          alert(res.message)
         
        } else {
          console.log('errror', res.error_message);
          alert(res.error_message)
        
        }
      })
      .catch(error => { });
  };


  useEffect(()=>{
    getProfile()
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
  },[])







  
  function getProfile() {
    getData(RECURITER_PROFILE)
    .then((response) => response.json())
      .then(async res => {
        // console.log('reeeesssspooonnnnssseeee', res)
        const response = res;
        if (response.status_code === 200) {
          // setMyProfle(res.data);
          console.log('oneeeeeeeeeeeeeeeeeee', response)
          setIsSwitchOn(response.data.email_notification)
       
        } else {
         
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
  const edit = () => {
    const obj = {
      current_password: currentPassword,
      password: newPassword,
    };
    console.log(currentPassword,newPassword,confirmPassword,"check password",obj)
    if(obj.current_password == undefined){
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.LoginPassword["Please Enter Valid Password"]:"");
    }else if(obj.password == undefined ){
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.LoginPassword["Please Enter Valid Password"]:"");
    }else{
      if(!validpassword(newPassword)){
        alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["passwordValidation"]:"");
      }
      else{
        if (newPassword === confirmPassword) {
          patchData(obj, UPDATE_PASSWORD)
            .then((response) => response.json())
            .then((response) => {
              console.log("EDIT", response);
              if(response.error_message != "Incorrect Authentication Credentials"){
                alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Password updated successfully"]:"");
              }else{
                alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation["Invalid Credentials"]:"");
              }
              
            })
            .catch((err) => {
              console.log(err.message);
            });
        } else {
          alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["New Password and Confirm Password does not match"]:"");
        }
      }
    }
    
  
    return "";
  };

  return (
    <>
      <div className="wrapped-content-area pt-2">
        <BackBar title={t("Setting")} />
        <div className="flex-center">
          <div className="login-container">
            <div style={{marginTop:10,marginBottom:10}}>
              <h6>{t("Email Notification")}</h6>
              <Switch value={isSwitchOn} onChange={updateEmailStatus} />
            </div>
            {/* <img src={UpdatePassword} alt="" className="login-img" /> */}
            <h6>{t("Update Password")}</h6>
            <div className="">
              <div className="input-container my-2">
                {/* --------------------Current password------------- */}
                <input
                  style={{ marginBottom: "1vw" }}
                  className="input-text w-100"
                  placeholder={t("Enter Current Password")}
                  type={showPassword ? "text" : "password"}
                  // defaultValue={`+91${phone}`}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  name=""
                  id=""
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    right: "15px",
                    top: "8%",
                  }}
                >
                  {" "}
                  {showPassword ? (
                    <i className="fa fa-eye" aria-hidden="true" />
                  ) : (
                    <i class="fa fa-eye-slash" aria-hidden="true" />
                  )}{" "}
                </span>

                {/* ----------------new password---------------- */}
                <input
                  style={{ marginBottom: "1vw" }}
                  className="input-text w-100"
                  placeholder={t("Enter New Password")}
                  type={showPasswordd ? "text" : "password"}
                  // defaultValue={`+91${phone}`}
                  onChange={(e) => setNewPassword(e.target.value)}
                  name=""
                  id=""
                />
                <span
                  onClick={() => setShowPasswordd(!showPasswordd)}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    right: "15px",
                    top: "40%",
                  }}
                >
                  {" "}
                  {showPasswordd ? (
                    <i className="fa fa-eye" aria-hidden="true" />
                  ) : (
                    <i class="fa fa-eye-slash" aria-hidden="true" />
                  )}{" "}
                </span>

                {/* -------------------Comfirm New Password------------- */}
                <input
                  style={{ marginBottom: "1vw" }}
                  className="input-text w-100"
                  placeholder={t("Confirm New Password")}
                  type={showPassworddd ? "text" : "password"}
                  // defaultValue={`+91${phone}`}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  name=""
                  id=""
                />
                <span
                  onClick={() => setShowPassworddd(!showPassworddd)}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    right: "15px",
                    top: "73%",
                  }}
                >
                  {" "}
                  {showPassworddd ? (
                    <i className="fa fa-eye" aria-hidden="true" />
                  ) : (
                    <i class="fa fa-eye-slash" aria-hidden="true" />
                  )}{" "}
                </span>
                {/* <img src="./images/call.png" alt="" className="left-img " /> */}
              </div>
            </div>

            <button
              className="theme-btn"
              onClick={() => {
                edit();
              }}
            >
              {t("Update Password")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
